import { Component, OnInit, ViewChild, AfterViewInit } from '@angular/core';
import { GoogleMapsAPIWrapper, AgmMap, LatLngBounds, LatLngBoundsLiteral } from '@agm/core';
/*
import { AngularFirestore } from 'angularfire2/firestore';
import { AngularFireObject, AngularFireDatabase } from 'angularfire2/database';
*/
import { Observable, combineLatest } from 'rxjs';
import { ActivatedRoute, Router } from '@angular/router';
import { TripList } from '../../../models/TripList';
import { UserList } from '../../../models/UserList';
import { RightinfoService } from '../../../service/rightinfo.service'
// import { Query } from '@firebase/database';
import { DatePipePipe } from '../../../pipes/date-pipe.pipe'
declare var google: any;
import { AwsService } from '../../../providers/appsyncservice/aws.service';
import { filter } from 'rxjs/operators';
import { runInThisContext } from 'vm';
import { InfoServiceService } from '../../../service/rightinfo/info-service.service';
import { AppConstants } from '../../../constants/app-constants';

@Component({
  selector: 'app-rightinfo',
  templateUrl: './rightinfo.component.html',
  styleUrls: ['./rightinfo.component.css']
})
export class RightinfoComponent implements OnInit {

  zoom: number = 12;
  // initial center position for the map
  lat: number = 12.73377;
  lng: number = 80.011268;
  @ViewChild('AgmMap') agmMap: AgmMap;
  allTrips: any;
  completedcount: number;
  runningcount: number;
  upcomingcount: number;

  markers = [];
  markersWithId = [];
  totaltrips: Observable<any[]>;
  showdirection = false;
  totalusers: any;
  allList: any[];
  // markers : MyMarker[] = new Array();

  alerts: Observable<any>;
  alertJson: any;
  alertList: Observable<any>;
  sosName: any;
  s_sosname: any;
  formatedUser = [];
  getseverity: any;
  alertType: any;
  allusers: any;
  getusername: any;
  getAllAlert: any;
  total = 0;
  comptotal = 0;

  triplistbydate: any

  triplist: TripList[];
  userList: any;
  // ref: Query;


  sos: Observable<any>;
  databaseRef: Observable<any>;
  completeddata: number = 0;
  totalTripCount = new Set();
  compdrivercount = new Set();
  completedList: any;
  sosJson: [any];
  sosCount = 0;
  // totalTripCount=0;
  driverlivecount = 0;
  currentDate: any;
  getType: any;
  screen: String;
  totalCount: number;

  private interval = 1000 * 60 * 60 * 24
  private startOfDay = Math.floor(Date.now() / this.interval) * this.interval
  private endDate = new Date(this.startOfDay + this.interval - 1)
  private startDate = new Date(this.startOfDay)

  constructor(public awserviceProvider: AwsService, private route: ActivatedRoute,
    private rightinfoService: RightinfoService, public router: Router, private infoService: InfoServiceService) {

    this.screen = infoService.getUrl();
    this.getTrips();

  }



  ngOnInit() { }



  addMarkerUserTrip(trip_id, lat, long) {
    this.markers = this.markers.filter((element) => {
      if (element.tripName == trip_id) {
        return false
      } else {
        return true
      }
    }
    )

    var marker = {
      lat: lat,
      lng: long,
      iconUrl: "assets/images/cab.png",
      tripName: trip_id
    }

    this.markers.push(marker);

  }

  getTrips() {

    this.awserviceProvider.getOpenSos().then(sosdata => {
      this.sosCount = sosdata.length
    })


    if (this.screen == AppConstants.HOME_SCREEN) {
      this, this.todayTrips();
    }
    else if (this.screen == AppConstants.REMAINING_SCREEN) {
      this.getCompletedDataCount();
      this.scheduledTrips();
      this.todayLiveTrips();
    }
    else if (this.screen == AppConstants.FINISHED_SCREEN){
      this.scheduledTrips();
    this.getCompletedDataCount();
   
    this.todayLiveTrips();
    }
  }


  todayTrips() {
    let dateFormat = require('dateformat');
    let now = new Date();
    let today = dateFormat(now, "yyyy-mm-dd");
    this.awserviceProvider.getCurrentDayTrip(today).then(trips => {
      this.allTrips = trips;
      let notstarted = this.allTrips.filter(trip => trip.status == 0);
      let running = this.allTrips.filter(trip => trip.status == 1);
      let complted = this.allTrips.filter(trip => trip.status == 2);
      this.upcomingcount = notstarted.length;
      this.runningcount = running.length;
      this.completedcount = complted.length;
      this.totalCount = this.upcomingcount + this.runningcount + this.completedcount;
    });
  }

  scheduledTrips() {

    let dateFormat = require('dateformat');
    let now = new Date();
    let today = dateFormat(now, "yyyy-mm-dd");

    this.awserviceProvider.getTripsByStatusCnt(0, today).then(remaining => {
      var triplist: any = remaining;
      //this.totalTripCount = triplist.length;
      this.upcomingcount  =triplist.length;
      if(this.screen == AppConstants.REMAINING_SCREEN){
        this.totalCount = triplist.length;
      }
     
    });
    

  }

  getCompletedDataCount() {
    let dateFormat = require('dateformat');
    let now = new Date();
    now.setDate(now.getDate() + 1);
    let tomorrow = dateFormat(now, "yyyy-mm-dd");

    var that = this
    this.awserviceProvider.getTripsByStatusCnt(2,tomorrow).then(finished => {
      let finishedlst: any = finished;
    //  this.compdrivercount  = finishedlst.length;
      this.completedcount  =finishedlst.length;
      if(this.screen == AppConstants.FINISHED_SCREEN){
        this.totalCount = this.completedcount;
      }
    })
  }

    todayLiveTrips(){
      let dateFormat = require('dateformat');
      let now = new Date();
      let today = dateFormat(now, "yyyy-mm-dd");

      this.awserviceProvider.getTripsByStatusCnt(1,today).then(running => {
        let runninglst: any = running;
        this.runningcount  = runninglst.length
  
      })
   
    
  }







}
